import { useMemo } from 'react'
import { PagesPDFWrapper } from '../../../../../features/ui'
import { toList } from '../../../../../utils/listUtils'
import { FiscalDocumentItem } from '../../../../fiscal-documents'
import { SaleOperation } from '../../../../sales'
import { AdjustmentNotePDFPage } from './adjustmentNotePDFPage'
import { AdjustmentNote } from '../../../state/types'

type Props = {
    id: string
    adjustmentNote: AdjustmentNote
    operation: SaleOperation
    previewMode?: boolean
}

export const AdjustmentNotePDF = (props: Props) => {
    const { id, adjustmentNote, operation, previewMode } = props

    const getPagesItems = (noteItems: FiscalDocumentItem[]) => {
        const pages: FiscalDocumentItem[][] = []
        const pushPages = (startIndex = 0) => {
            const isFirstPage = startIndex === 0
            const remainingItems = noteItems.slice(startIndex)
            if (remainingItems.length > 0) {
                const maxPageSize = isFirstPage ? 10 : 13
                const pageSize = remainingItems.length < maxPageSize ? maxPageSize - 2 : (remainingItems.length === maxPageSize ? maxPageSize - 1 : maxPageSize)
                pages.push(remainingItems.slice(0, pageSize))
                pushPages(startIndex + pageSize)
            }
        }
        pushPages()

        return pages
    }

    const pagesItems = useMemo(() => getPagesItems(adjustmentNote.items), [adjustmentNote.items])

    const renderPages = pagesItems.length > 0 ?
        pagesItems.map((pageItems, pageIndex) => (_: number) => (
            <AdjustmentNotePDFPage
                key={pageIndex}
                adjustmentNote={adjustmentNote}
                operation={operation}
                items={pageItems}
                pageIndex={pageIndex}
                pagesAmount={pagesItems.length}
            />
        )) :
        toList(() => (
            <AdjustmentNotePDFPage
                adjustmentNote={adjustmentNote}
                operation={operation}
                items={adjustmentNote.items}
                pageIndex={0}
                pagesAmount={1}
            />
        ))

    return (
        <PagesPDFWrapper
            id={id}
            dataType={adjustmentNote}
            previewMode={previewMode}
            renderPages={renderPages}
        />
    )
}
